/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../../base.model';
import { EquipmentRateDto } from './EquipmentRateDto';

export class EquipmentDispatchDto extends BaseModel {
  public EquipmentDispatchIDs: string[];
  public EquipmentIDs: string[];
  public JobID: string;
  public EquipmentName: string;
  public Name: string;
  public BillingEquipmentName: string;
  public BillingName: string;
  public StartDate: Date;
  public EndDate: Date;
  public bActive: boolean;
  public Note: string;
  public AltID: string;
  public CustomerID: string;
  public Rates: EquipmentRateDto[];
  public EquipmentKeyID: number;
  public vpCompanyID: number | null;

  constructor(o: unknown = null) {
    super(o);
  }
}
